/* Free gifts — "Includes Free …" on the Add to cart button
   ---------------------------------------------------------------------------
   For automatic promotions. gift-promo.js puts an auto promotion's gift into
   the cart by itself the moment the qualifying product lands, so the product
   page has no chooser to show — but the shopper should still know the gift is
   coming, at the moment they commit. This fuses a strip onto the bottom of the
   buy button: "+ Includes Free Armrest Pads — £24.95 value".

   Successor to free-gift-cta.js, which read Kite's widget and had to infer
   which variants qualified from the campaign's wording ("*Leather Zephyr
   Only"); here the qualifying variants are listed outright in the promotion,
   so the check is exact.

   FAILS CLOSED. The strip promises something free, so every unknown is a no:
   no qualifying variant selected, a sold-out button, or anything on screen
   that disagrees with the form. The last one matters because the swatch app
   can mark "Fabric" selected without the form's variant ever changing — the
   case that once had armrest pads promised on Fabric Zephyrs. */

(function () {
  if (window.giftPromoCtaLoaded) return;
  window.giftPromoCtaLoaded = true;

  var MOUNT = "[data-gift-promo-cta]";
  var SHOWN_CLASS = "gp-cta--shown";

  var priceByPromo = {};
  var loading = {};

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function norm(s) {
    return String(s == null ? "" : s).trim().toLowerCase();
  }

  function mount() {
    return document.querySelector(MOUNT);
  }

  function productId() {
    var el = mount();
    return el ? el.getAttribute("data-product-id") : null;
  }

  /* The selected variant, straight from the form that will be submitted — the
     only authoritative answer to "what is this shopper actually buying". The
     duplicate input the theme renders for the sticky bar is disabled, so skip
     those; fall back to the URL and the theme's own variant select. */
  function selectedVariantId() {
    var inputs = document.querySelectorAll('form input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].disabled && inputs[i].value) return inputs[i].value;
    }
    var fromUrl = new URLSearchParams(window.location.search).get("variant");
    if (fromUrl) return fromUrl;
    var select = document.querySelector('select[name="id"]');
    return select && select.value ? select.value : null;
  }

  // Option data rendered by product-information.liquid (#fg-variant-data).
  // Parsed once.
  var variantData;
  function readVariantData() {
    if (variantData !== undefined) return variantData;
    variantData = null;
    var el = document.getElementById("fg-variant-data");
    if (el) {
      try {
        var parsed = JSON.parse(el.textContent);
        if (parsed && parsed.options && parsed.variants) variantData = parsed;
      } catch (e) {}
    }
    return variantData;
  }

  // Every option value on show in the pickers, whichever widget owns them.
  function visibleSelections() {
    var out = [];
    document.querySelectorAll(".swatch-button.swatch-selected").forEach(function (button) {
      out.push((button.textContent || "").trim());
    });
    document.querySelectorAll('.variations input[type="radio"]:checked').forEach(function (radio) {
      out.push(radio.value);
    });
    document.querySelectorAll(".variations select[name]").forEach(function (select) {
      out.push(select.value);
    });
    return out.filter(Boolean).map(norm);
  }

  /* The trigger entry for this product in this promotion, if it has one. */
  function triggerFor(promo, pid) {
    var GP = window.GiftPromo;
    return promo.triggers.filter(function (t) { return GP.numeric(t.product) === String(pid); })[0] || null;
  }

  /* Does anything on screen contradict a qualifying selection? Only asked of
     triggers restricted to certain variants — with no restriction, every
     variant qualifies and there is nothing to contradict.

     For each option the restriction narrows (Material, on the Zephyr), the
     allowed values are those of the qualifying variants. Any visible value for
     that option outside them withholds the strip: two widgets can own one
     option and disagree, and one of them showing "Fabric" is enough. */
  function contradicted(trigger) {
    var variants = Array.isArray(trigger.variants) ? trigger.variants : [];
    if (!variants.length) return false;

    var data = readVariantData();
    // Restricted, and no data to check the page against: cannot prove it.
    if (!data) return true;

    var GP = window.GiftPromo;
    var allowedRows = variants.map(function (v) { return data.variants[GP.numeric(v.id)]; }).filter(Boolean);
    if (!allowedRows.length) return true;

    var visible = visibleSelections();
    return data.options.some(function (option, index) {
      var optionValues = option.values.map(norm);
      var allowed = allowedRows.map(function (row) { return norm(row[index]); });
      // An option every value of which is allowed is not narrowed at all.
      var narrowed = optionValues.some(function (v) { return allowed.indexOf(v) === -1; });
      if (!narrowed) return false;
      var seen = visible.filter(function (v) { return optionValues.indexOf(v) !== -1; });
      return seen.some(function (v) { return allowed.indexOf(v) === -1; });
    });
  }

  // The automatic promotion the selected variant earns, if any.
  function earned() {
    var GP = window.GiftPromo;
    var pid = productId();
    var vid = selectedVariantId();
    if (!GP || !pid || !vid) return null;

    return GP.promotions().filter(function (promo) {
      if (promo.mode !== "auto") return false;
      if (!GP.variantQualifies(promo, pid, vid)) return false;
      var trigger = triggerFor(promo, pid);
      return !!trigger && !contradicted(trigger);
    })[0] || null;
  }

  function loadPrice(promo) {
    if (loading[promo.id]) return;
    loading[promo.id] = window.GiftPromo.options(promo.id).then(function (gifts) {
      priceByPromo[promo.id] = gifts[0] || null;
      apply();
    });
  }

  /* What the strip promises also rides along with Add to cart (see rideAlong in
     gift-promo.js), so the gift lands with the product rather than after it.
     Registered only while the strip shows and the gift is known, so it rides
     exactly when the shopper has been told it is included. */
  var riding = null;

  function ride(promoId, variantId) {
    if (riding && riding !== promoId) window.GiftPromo.rideAlong(riding, null);
    riding = variantId ? promoId : null;
    if (promoId) window.GiftPromo.rideAlong(promoId, variantId, productId());
  }

  function clearStrip() {
    if (riding) ride(riding, null);
    var strip = document.querySelector(".gp-cta__strip");
    if (strip) strip.remove();
    var button = document.getElementById("AddToCart");
    if (button) button.classList.remove("gp-cta-btn");
    document.documentElement.classList.remove(SHOWN_CLASS);
  }

  function apply() {
    var button = document.getElementById("AddToCart");
    if (!button) return;

    var promo = earned();
    // Nothing to promise while the variant is sold out, either.
    if (!promo || button.disabled) {
      clearStrip();
      return;
    }

    if (!(promo.id in priceByPromo)) loadPrice(promo);
    var gift = priceByPromo[promo.id];
    ride(promo.id, gift ? gift.variantId : null);
    var name = (gift && (gift.label || gift.title)) || (promo.gifts[0] && promo.gifts[0].label) || "gift";
    var value = gift && gift.price != null ? window.GiftPromo.money(gift.price) : "";

    var text = "Includes Free <b>" + esc(name) + "</b>";
    if (value) text += " — " + esc(value) + " value";

    // Render inside the button itself so both halves of the pill are the button.
    button.classList.add("gp-cta-btn");

    /* Move the label and the theme's spinner into a wrapper that carries the red
       fill. The theme zeroes the opacity of every span in a loading button, so a
       fill on the label itself vanished on press and left a blank outline. The
       running-total pill (atc-running-total.liquid) and its arrow come along,
       or they would be left as direct children of the button — which is
       display:block here, putting the price on its own line between the two
       halves. */
    var label = button.querySelector(".single-add-to-cart-button--text");
    if (label && !button.querySelector(".gp-cta__main")) {
      var main = document.createElement("span");
      main.className = "gp-cta__main";
      label.parentNode.insertBefore(main, label);
      main.appendChild(label);
      ["[data-atc-total]", ".atc-total-arrow", ".loading-overlay"].forEach(function (sel) {
        var el = button.querySelector(sel);
        if (el) main.appendChild(el);
      });
    }

    var strip = button.querySelector(".gp-cta__strip");
    if (!strip) {
      strip = document.createElement("span");
      strip.className = "gp-cta__strip";
      button.appendChild(strip);
    }

    var html = '<span class="gp-cta__plus" aria-hidden="true">+</span><span>' + text + "</span>";
    if (strip.innerHTML !== html) strip.innerHTML = html;
    document.documentElement.classList.add(SHOWN_CLASS);
  }

  function start() {
    apply();
    // The button and the variant data both arrive on their own schedule.
    var interval = setInterval(apply, 400);
    setTimeout(function () { clearInterval(interval); }, 15000);

    /* Variant changes re-render the section, so re-check on every DOM change —
       observing document.body, since the re-render replaces the containers.
       class is watched as well as childList because the swatch app signals its
       selection by toggling .swatch-selected, an attribute-only change. The
       rAF gate collapses bursts into one pass, and apply() is idempotent, so
       our own mutations settle at once. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    // A change event fires before the re-render it triggers has landed.
    document.addEventListener("change", function () {
      apply();
      [400, 1200, 2500].forEach(function (delay) { setTimeout(apply, delay); });
    }, true);
  }

  function watchForBoot() {
    if (mount() && window.GiftPromo) return start();
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (mount() && window.GiftPromo) {
        clearInterval(interval);
        start();
      } else if (tries > 40) {
        clearInterval(interval);
      }
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchForBoot);
  } else {
    watchForBoot();
  }
})();
